import React, {
  useEffect,
  useMemo,
} from "react";
import "./TiktokData.css";
import { useLoadTypeContentData } from "../../../../Utils/customHooks/UpToDateContent/useLoadTypeContent";
import { getContentFeedDateWindowFromComponent } from "../../../../Screens/DashboardView/StayUpToDate/AddComponentPicker/contentFeedTimeframe";
import { StayFeedLoadingPlaceholder } from "../../../../Screens/DashboardView/MasterTemplateEditor/WebsiteLibFeedSkeleton";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  handleFirstImage,
  updateIsEmptyStatus,
} from "../../../../Utils/StayUpToDate/RenderComponent";
import { StaticVariables } from "../../../../Utils/StaticVariables";
import { useDomLoaded } from "../../../../hooks/DomLoadedContext";
import PostTemplate from "../CommonComponents/PostTemplate";
import { FeedSectionEmptyState } from "../FeedSectionEmptyState";
import { websiteEditorFeedEmptyMessage } from "../../../../Screens/DashboardView/MasterTemplateEditor/websiteEditorFeedEmptyMessage";

const TiktokData = (props: any) => {
  let platform = "tiktok";
  let type = "TIKTOK";
  const itemsPerPage = 3;

  const {
    user_id,
    username,
    handleRedirect,
    brand_color,
    title,
    isHandleNavigate,
    component,
    removedPostIds,
    from,
    designTokens,
    templateGridLoaderProps,
    isLinks,
    showEmptyInEditor = false,
  } = props;
  const contentDateWindow = useMemo(
    () => getContentFeedDateWindowFromComponent(component),
    [component?.details, component?.id]
  );

  const {
    isLoading: TiktokDataLoading,
    data: TiktokData,
    total_count,
  }: any = useLoadTypeContentData(
    username,
    user_id,
    platform,
    type,
    component?.removed_postids,
    component?.content_order,
    component?.custom_order?.split(","),
    component?.shoppable_content_filter,
    (component?.pinned_posts?.split(",") || [])
      .map((id: any) => String(id).trim())
      .filter((id: string) => id !== ""),
    component?.shoppable_status_filter || "all",
    "default",
    "default",
    true,
    contentDateWindow
  );
  const showSocials =
    component.shoppable_content_filter === "content"
      ? StaticVariables().CONTENT_PLATFORMS
      : component.shoppable_content_filter === "products"
      ? StaticVariables().PRODUCT_PLATFORMS
      : null;

  // Process pages data similar to ReelsDataLoader pattern
  // Flatten pages array: each page is { data: [...], total_count: ..., originalDataLength: ... }
  // Extract data arrays from each page and flatten them
  const processedData = useMemo(() => {
    if (!TiktokData?.pages || !Array.isArray(TiktokData.pages)) return [];

    // Flatten pages: extract data array from each page object
    const flattened = TiktokData.pages.flatMap((page: any) => page?.data || []);

    // Apply socials filter if needed
    if (showSocials) {
      return flattened
        .filter((element: any) => element !== undefined)
        .filter((item: any) => showSocials.includes(item.platform));
    }

    return flattened;
  }, [TiktokData?.pages, showSocials]);

  const param = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const domLoaded = useDomLoaded();

  useEffect(() => {
    const checkEmptyStatus = async () => {
      if (!TiktokDataLoading) {
        if (!processedData || processedData.length === 0 || total_count === 0) {
          if (!showEmptyInEditor) {
            await updateIsEmptyStatus(title, user_id, component.id,from);
          }
        } else {
          await handleFirstImage(
            title,
            component?.id,
            processedData[0],
            user_id,
            from
          );
        }
      }
    };
    checkEmptyStatus();
  }, [
    TiktokDataLoading,
    processedData,
    total_count,
    title,
    user_id,
    component?.id,
  ]);

  return (
    <>
      {TiktokDataLoading || !domLoaded ? (<StayFeedLoadingPlaceholder
          designTokens={designTokens}
          from={from}
          component={component}
          templateGridLoaderProps={templateGridLoaderProps}
        />) : (
        <>
          {processedData && processedData.length > 0 && total_count > 0 ? (
            <PostTemplate
              processedData={processedData}
              total_count={total_count}
              component={component}
              user_id={user_id}
              username={username}
              handleRedirect={handleRedirect}
              brand_color={brand_color}
              title={title}
              from={from}
              type={type}
              isLinks={isLinks}
              itemsPerPage={itemsPerPage}
              designTokens={designTokens}
              pinnedPostIds={(component?.pinned_posts?.split(",") || [])
                .map((id: any) => String(id).trim())
                .filter((id: string) => id !== "")}
            />
          ) : showEmptyInEditor ? (
            <FeedSectionEmptyState
              title={title}
              designTokens={designTokens}
              message={websiteEditorFeedEmptyMessage("platform", { platform: "TikTok" })}
            />
          ) : (
            ""
          )}
        </>
      )}
    </>
  );
};

export default TiktokData;
